<template>
  <div v-if="visible" class="draw-result__overlay" :style="{ zIndex }" @click.self="$emit('close')">
    <div :class="['draw-result', isPC ? 'is-pc' : 'is-h5']">
      <!-- 顶部文案 -->
      <p v-if="!isPC" class="draw-result__headline">
        <template v-for="(line, index) in headlineLines">
          <br v-if="index > 0" :key="`break-${line}`" />
          <span :key="line">{{ line }}</span>
        </template>
      </p>

      <!-- 主卡片 -->
      <div class="draw-result__card">
        <div v-if="isPC" class="draw-result__text-panel">
          <p class="draw-result__headline draw-result__headline--pc">
            <template v-for="(line, index) in headlineLines">
              <br v-if="index > 0" :key="`pc-break-${line}`" />
              <span :key="`pc-${line}`">{{ line }}</span>
            </template>
          </p>
          <div class="draw-result__pc-footer">
            <p class="draw-result__task-hint draw-result__task-hint--pc">
              Keep your assets above $1,000 to complete the task and unlock your rewards.
            </p>
            <div class="draw-result__actions">
              <button class="draw-result__btn draw-result__btn--pc" @click="$emit('brag')">
                Brag to Friends
              </button>
            </div>
          </div>
        </div>

        <!-- 奖品素材图 -->
        <div class="draw-result__asset-area">
          <img
            v-if="matchedAsset"
            :src="matchedAsset"
            class="draw-result__asset-img"
            alt="prize"
          />
          <img class="draw-result__lock" :src="drawResultLockSrc" alt="" />
        </div>

        <!-- 底部区域 -->
        <div v-if="!isPC" class="draw-result__footer">
          <p class="draw-result__task-hint">
            Keep your assets above $1,000 to complete the task and unlock your rewards.
          </p>
          <button class="draw-result__btn" @click="$emit('brag')">
            Brag to Friends
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed } from 'vue-demi';
import type { DrawStatus, PrizeType } from '@ark/mets-shared';
import type { PrizeConfig } from '../../shared/types';
import drawResultLockSrc from '../assets/draw-result-lock.png';
const __sfc_main = {};
__sfc_main.props = {
  visible: {
    key: "visible",
    required: true,
    type: Boolean
  },
  drawResult: {
    key: "drawResult",
    required: true,
    type: [Object, null]
  },
  prizeConfigs: {
    key: "prizeConfigs",
    required: true,
    type: Array
  },
  isPC: {
    key: "isPC",
    required: true,
    type: Boolean
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    useZIndex,
    useTeleport
  } = (require('@fegobull/webapi') as any).use;
  useTeleport(document.body);
  const zIndex = useZIndex();
  const props = __props;
  const matchedConfig = computed(() => {
    const prizeId = props.drawResult?.prize?.prizeId;
    if (!prizeId) return null;
    return props.prizeConfigs.find(p => p.prizeId === prizeId) ?? null;
  });
  const isGrandPrize = computed(() => matchedConfig.value?.isGrandPrize ?? false);
  const matchedAsset = computed(() => matchedConfig.value?.prizeAsset ?? '');
  const headlineLines = computed(() => isGrandPrize.value ? ['JACKPOT!', 'You Scored the Grand Prize!'] : ['Congratulations, You got']);
  return {
    drawResultLockSrc,
    zIndex,
    matchedAsset,
    headlineLines
  };
};
export default __sfc_main;
</script>

<style scoped>
.draw-result__overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}

.draw-result {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90%;
  font-family: BR Hendrix, Arial, sans-serif;
}

.draw-result__headline {
  font-weight: 700;
  color: #fff;
  text-align: center;
  margin: 0;
  line-height: 1.2;
  white-space: nowrap;
}

.draw-result__card {
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
  background: #fff;
}

.draw-result__asset-area {
  position: relative;
  width: 100%;
  aspect-ratio: 630 / 670;
  background: linear-gradient(180deg, #ff7721 0%, #be2005 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.draw-result__asset-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.draw-result__lock {
  position: absolute;
  top: 0;
  right: 0;
  display: block;
  pointer-events: none;
}

.draw-result__footer {
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.draw-result__task-hint {
  font-size: 14px;
  color: #7a7a7a;
  text-align: center;
  margin: 0;
  line-height: 1.4;
}

.draw-result__actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 10px;
}

.draw-result__btn {
  border: none;
  font-family: BR Hendrix, Arial, sans-serif;
  cursor: pointer;
}

.draw-result__btn {
  background: #ff6900;
  color: #fff;
  border-radius: 200px;
  padding: 14px 40px;
  font-size: 15px;
  font-weight: 600;
}

/* H5 */
.draw-result.is-h5 {
  width: 6.3rem;
  gap: 0.28rem;
}

.draw-result.is-h5 .draw-result__headline {
  font-size: 0.48rem;
}

.draw-result.is-h5 .draw-result__card {
  border-radius: 0.4rem;
}

.draw-result.is-h5 .draw-result__footer {
  padding: 0.32rem 0.4rem;
  gap: 0.2rem;
}

.draw-result.is-h5 .draw-result__task-hint {
  font-size: 0.28rem;
}

.draw-result.is-h5 .draw-result__btn {
  padding: 0.16rem 0.24rem;
  font-size: 0.3rem;
  border-radius: 2rem;
  width: 100%;
}

.draw-result.is-h5 .draw-result__lock {
  width: 0.6rem;
  height: 0.6rem;
}

/* PC */
.draw-result.is-pc {
  width: auto;
}

.draw-result.is-pc .draw-result__card {
  display: flex;
  flex-direction: row;
  width: 760px;
  border-radius: 20px;
}

.draw-result.is-pc .draw-result__text-panel {
  display: flex;
  flex: 0 0 380px;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  width: 380px;
  height: 480px;
  padding: 40px;
  background: #ffffff;
}

.draw-result.is-pc .draw-result__headline {
  color: #262626;
  text-align: left;
  white-space: normal;
}

.draw-result.is-pc .draw-result__headline--pc {
  font-size: 40px;
  letter-spacing: -0.02em;
}

.draw-result.is-pc .draw-result__pc-footer {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}

.draw-result.is-pc .draw-result__task-hint--pc {
  font-size: 16px;
  letter-spacing: -0.02em;
  text-align: left;
}

.draw-result.is-pc .draw-result__asset-area {
  flex: 0 0 380px;
  width: 380px;
  height: 480px;
  aspect-ratio: auto;
}

.draw-result.is-pc .draw-result__lock {
  width: 40px;
  height: 40px;
}

.draw-result.is-pc .draw-result__btn--pc {
  width: 220px;
  height: 58px;
  padding: 0;
  border-radius: 30px;
  font-size: 20px;
  line-height: 1;
}
</style>
